import React from "react"
import { Container, Button, Modal, Form, Col, InputGroup, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import ActionButton from "../ActionButton"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import UserPasswordReset from "../../api/Administration/UserPasswordReset"
import { APIError } from "../../api/ObservableFromFetch"
import { EmailRegexp } from "../../config/Constants"
import { getLoggedInUserName } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"


interface ChangePasswordModalProps {
  LoginName: string
  show: boolean
  onCancel: () => void
  onSubmit: () => void
}

interface ChangePasswordModalState {
  loginName: string
  isEmailValid: boolean
  dataSaving: boolean
}


export class ChangePasswordModal extends React.Component<ChangePasswordModalProps, ChangePasswordModalState> {

  emptyState: ChangePasswordModalState = {
    loginName: "",
    isEmailValid: false,
    dataSaving: false
  }

  state: ChangePasswordModalState = { ...this.emptyState }

  userPasswordResetSubscription?: Subscription


  componentWillUnmount() {
    this.userPasswordResetSubscription && this.userPasswordResetSubscription.unsubscribe()
  }
  handleAPIError = (error: Error | APIError) => {
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  handleCancel = () => {
    this.props.onCancel()
  }
  handleSubmit = () => {
    const loginName = this.state.loginName;
    this.setState({ dataSaving: true })
    this.userPasswordResetSubscription && this.userPasswordResetSubscription.unsubscribe()

    this.userPasswordResetSubscription = UserPasswordReset(loginName, window.location.href, false).subscribe(
      data => {
        toast.success(data);
        this.setState({ dataSaving: false });
        this.props.onSubmit();
      },
      (error) => {
        this.handleAPIError(error);
        this.setState({ dataSaving: false });
      }
    )

  }

  isEmailValid = (value: string) => {
    if (value.length === 0) {
      return false
    }
    return EmailRegexp.test(value)
  }

  handleEmailChange = (value: string) => {
    this.setState(
      {
        loginName: value,
        isEmailValid: this.isEmailValid(value)
      })
  }



  render() {
    this.state.loginName = this.props.LoginName;
    this.state.isEmailValid = this.isEmailValid(this.props.LoginName);
    const { loginName, isEmailValid, dataSaving } = this.state;

    return (

      <Modal backdrop="static" size="lg" dialogClassName="dark" show={this.props.show}>
        <Modal.Header>
          <Modal.Title className="text-uppercase">CHANGE PASSWORD</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container fluid>
              <Row>
                <Col>
                  <p>Please enter your email address, click Submit and we will send you an email that contains a link to click on that requests a PIN number to change your password.</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    id="parameterTitle"
                    className="bg-white"
                    type="text"
                    maxLength={50}
                    value={loginName}
                    onChange={e => this.handleEmailChange(e.target.value)}
                    disabled={dataSaving || true}
                  />
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleCancel} disabled={dataSaving} className="mr-auto">Cancel</Button>
          <ActionButton
            variant="primary"
            onClick={this.handleSubmit}
            disabled={dataSaving || !isEmailValid} spin={dataSaving} disableOnSpin>Submit</ActionButton>
        </Modal.Footer>
      </Modal>

    )
  }

}

